import { EXERCISES_ACTION, EXERCISES_PATH } from '../../constants'
import { getCurrentExerciseSelector } from '../../selectors/get-current'
import { logUtil } from 'packages/src'
import REDUX_OPTION from '../../../../redux/constants/option'
import { saveReduxAction } from '../../../../redux/actions'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'

function saveExerciseAction (params = {}) {
  return (dispatch, getState) => {
    const exercise = getCurrentExerciseSelector(getState())
    const options = {
      ...(
        params.options || {}
      ),
      [REDUX_OPTION.IS_IMMEDIATE]: true,
      [REDUX_OPTION.SHOW_ERROR]: true
    }
    logUtil('saveExerciseAction')
      .debug('exercise: ', exercise)
    return dispatch(saveReduxAction({
      type: EXERCISES_ACTION.SAVE,
      payload: {
        domainListPath: EXERCISES_PATH.CREATED,
        path: getPathReduxUtil(exercise),
        ...params,
        options
      }
    }))
  }
}

export { saveExerciseAction }
